import Insight from "../insightClass";
import React from "react";
import {
  Top10HeadlinesCover,
  Top10HeadlinesPreview,
  Top10HeadlinesPDF,
} from "../../../assets/assetReference";
import { ContactSubscribe } from "../../../components/Contact/Contact";
export const insight086 = new Insight(
  "31 December 2025",
  {
    pageTitle: "2025 Top 10 Offshore Wind Headlines in Europe",
    metaDescription:
      "WeBridge Insights, 2025 Top 10 Offshore Wind Headlines in Europe",
    keyWords:
      "European Offshore Wind Market development, 2025 Top 10 Offshore Wind Headlines in Europe",
  },
  {
    src: Top10HeadlinesCover,
    alt: "2025 Top 10 Offshore Wind Headlines in Europe (special)",
  },
  "2025 Top 10 Offshore Wind Headlines in Europe",
  "",
  `2025 was a pivotal year for the European offshore wind industry, marked by impressive milestones as well as significant challenges. Major projects came online and new technologies were demonstrated, even as rising costs and policy hurdles led to high-profile setbacks. Below are the top 10 most talked- about news stories and events in European (including UK) offshore wind for 2025 and why they mattered from a WeBridge perspective.`,
  <div>
    <strong>WeBridge Insights</strong>
    <h1>2025 Top 10 Offshore Wind Headlines in Europe</h1>
    <h2></h2>
    <p className="article-date">31 December 2025</p>
    <br />
    <br />
    <br />
    <p>
      2025 was a pivotal year for the European offshore wind industry, marked by
      impressive milestones as well as significant challenges. Major projects
      came online and new technologies were demonstrated, even as rising costs
      and policy hurdles led to high-profile setbacks. Below are the top 10 most
      talked- about news stories and events in European (including UK) offshore
      wind for 2025 and why they mattered from a WeBridge perspective.
    </p>
    <div style={{ textAlign: "center", margin: "30px 0" }}>
      <a
        href={Top10HeadlinesPDF}
        download="WeBridge Insights - 2025 Top 10 Offshore Wind Headlines in Europe.pdf"
        style={{
          textDecoration: "none",
          marginBottom: "10px",
        }}
      >
        <img
          className="shadow-lg"
          src={Top10HeadlinesPreview}
          alt="Preview of 2025 Top 10 Offshore Wind Headlines in Europe"
          style={{
            display: "block",
            margin: "0 auto 16px auto",
            // border: "none !important",
            border: "1px solid transparent",
          }}
        />
        <br />
        Download full insight as PDF
      </a>
    </div>
    <br />
    <br />
    <br />
    <p>
      As the global offshore wind sector continues to advance, innovation,
      investments, and supportive policies are driving transformative growth. At{" "}
      <i>
        <b>WeBridge</b>
      </i>
      , we provide the expertise and insights our partners need to confidently
      navigate this evolving landscape.
    </p>
    <h3 style={{ marginTop: "200px" }}>Subscribe</h3>
    <ContactSubscribe />
  </div>,
);
